import { match, P } from 'ts-pattern';
import type {
    WhereItem,
    WhatWhoItem,
} from '$components/SearchHeader/SearchHeaderFormData';

export function matchWhereItem<A, B = A, C = A, D = A>(
    whereItem: WhereItem,
    callbacks: {
        city: (id: number) => A;
        subCity: (id: number) => B;
        district: (id: number) => C;
        country: (country: string) => D;
    },
): A | B | C | D {
    return match(whereItem)
        .with({ cityId: P.number.select() }, callbacks.city)
        .with({ subCityId: P.number.select() }, callbacks.subCity)
        .with({ districtId: P.number.select() }, callbacks.district)
        .with({ countryId: P.string.select() }, callbacks.country)
        .with(
            {
                cityId: P.nullish,
                subCityId: P.nullish,
                districtId: P.nullish,
                countryId: P.nullish,
            },
            {},
            () => {
                throw new Error('Invalid WhereItem');
            },
        )
        .exhaustive();
}

export function matchWhatWhoItem<A, B = A, C = A, D = A>(
    item: WhatWhoItem,
    callbacks: {
        user: (id: number) => A;
        category: (id: number) => B;
        company: (id: number) => C;
        shoppingProduct: (id: number) => D;
    },
): A | B | C | D {
    return match(item)
        .with({ userId: P.number.select() }, callbacks.user)
        .with({ categoryId: P.number.select() }, callbacks.category)
        .with({ companyId: P.number.select() }, callbacks.company)
        .with({ shoppingProductId: P.number.select() }, callbacks.shoppingProduct)
        .with(
            {
                userId: P.nullish,
                categoryId: P.nullish,
                companyId: P.nullish,
                shoppingProductId: P.nullish,
            },
            {},
            () => {
                throw new Error('Invalid WhatWhoItem');
            },
        )
        .exhaustive();
}
